import React from 'react'

function ENUS() {
    return (
        <div>
            <strong>Privacy Policy</strong>
            <p>This privacy policy applies to the QualySessa app ("Application") for mobile devices, created by Devenger ("Service Provider") as a free service. This service is provided "AS IS".</p>

            <strong>Information Collection and Use</strong>
            <p>The Application collects information when you download and use it. This may include:</p>
            <ul>
                <li>Your device's Internet Protocol address (IP address)</li>
                <li>Pages visited within the Application, time and date of visits, duration of visits</li>
                <li>Total time spent using the Application</li>
                <li>Operating system of your mobile device</li>
            </ul>

            <p>The Application does not collect precise location data of your mobile device.</p>

            <p>The Service Provider may use your provided information to contact you for important notices and marketing promotions.</p>

            <strong>Third Party Access</strong>
            <p>Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application. Below is a link to the third-party service provider used:</p>
            <ul>
                <li><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google Play Services</a></li>
            </ul>

            <p>The Service Provider may disclose collected information:</p>
            <ul>
                <li>As required by law, such as to comply with subpoenas or legal processes</li>
                <li>To protect rights, ensure safety, investigate fraud, or respond to government requests</li>
                <li>With trusted service providers acting on behalf of the Service Provider under privacy agreements</li>
            </ul>

            <strong>Opt-Out Rights</strong>
            <p>You can stop information collection by uninstalling the Application using standard device or marketplace methods.</p>

            <strong>Data Retention Policy</strong>
            <p>The Service Provider retains user-provided data as long as you use the Application and for a reasonable period afterward. To request deletion, contact webmaster@devenger.com.br.</p>

            <strong>Children</strong>
            <p>The Application is not intended for children under 13. If a child under 13 provides personal data, it will be deleted immediately. Parents or guardians can contact webmaster@devenger.com.br for necessary actions.</p>

            <strong>Security</strong>
            <p>The Service Provider implements physical, electronic, and procedural safeguards to protect collected information.</p>

            <strong>Changes</strong>
            <p>This Privacy Policy may be updated periodically. Changes will be reflected on this page. Continued use of the Application constitutes acceptance of updates.</p>

            <p>This privacy policy is effective as of 2025-02-12.</p>

            <strong>Your Consent</strong>
            <p>By using the Application, you consent to the processing of your information as described in this Privacy Policy.</p>

            <strong>Contact Us</strong>
            <p>For any privacy-related questions, contact webmaster@devenger.com.br.</p>

            <hr />
            <p>This privacy policy page was generated by <a href="https://app-privacy-policy-generator.nisrulz.com/" target="_blank" rel="noopener noreferrer">App Privacy Policy Generator</a></p>
        </div>
    )
}

export default ENUS